export default "__VITE_ASSET__B7Y$QU____"